import React from "react";
import { goToExternalUrl } from "../../utils";
import {
  KRF_IMPACT_VIDEO_URL,
  KRF_IMPACT_VIDEO_EMBED_URL
} from "../../constants";
import {
  Section,
  Inner,
  TextSide,
  SectionTitle,
  SectionBody,
  WatchButton,
  VideoSide,
  VideoContainer
} from "./styled.components";

const SeeKrfImpact: React.FC = () => {
  return (
    <Section>
      <Inner>
        <TextSide>
          <SectionTitle>See KRF's Impact in Action</SectionTitle>
          <SectionBody>
            Watch how KRF is advancing food allergy education, emergency
            preparedness, and public health solutions across Arizona
            communities.
          </SectionBody>
          <WatchButton onClick={() => goToExternalUrl(KRF_IMPACT_VIDEO_URL)}>
            Watch Our Impact
          </WatchButton>
        </TextSide>
        <VideoSide>
          <VideoContainer>
            <iframe
              src={KRF_IMPACT_VIDEO_EMBED_URL}
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              title="KRF Impact Video"
            />
          </VideoContainer>
        </VideoSide>
      </Inner>
    </Section>
  );
};

export default SeeKrfImpact;
